<template>
	<div>
		<p v-if="$tera.project.TrialWizard.interventions">
			<!-- Intervention -->
			{{
				selectRandom([
					`There ${
						$tera.project.TrialWizard.interventions.length > 1 ? "are" : "is"
					}`,
					"This trial are ",
					"This trial will be ",
					"We are planning for this trial to be ",
					"This trial is a "
				])
			}}
			{{ $tera.project.TrialWizard.interventions.length }}
			{{
				selectRandom([
					`intervention ${interventionArmOrArms}: the `,
					`${interventionArmOrArms} for the intervention: the`
				])
			}}
			{{
				$tera.project.TrialWizard.interventions
					? joinArrayWithAnd(
							$tera.project.TrialWizard.interventions.map(
								el => el.name + " group"
							)
					  )
					: "BLANK"
			}}.
		</p>
		<p
			v-for="(intervention, index) of $tera.project.TrialWizard.interventions"
			:key="`intervention-${index}`"
		>
			{{
				selectRandom([
					"Participants in the ",
					"The participants assigned to the ",
					"Participants assigned to the ",
					"Participants delegated in the "
				])
			}}
			{{ intervention.name }}
			{{ selectRandom(["group received ", "group, were given "]) }}
			{{ intervention.materials }}.
			<span v-if="intervention.instructions"
				>They were instructed to {{ intervention.instructions }}.</span
			>
		</p>

		<!-- Control -->
		<p v-if="$tera.project.TrialWizard.control">
			{{
				selectRandom([
					`There ${$tera.project.TrialWizard.control.length > 1 ? "are" : "is"}`,
					"This trial has ",
					"The trial has ",
					"The trial will have "
				])
			}}
			{{ $tera.project.TrialWizard.control.length }}
			{{
				selectRandom([
					`control ${controlArmOrArms}: the `,
					`${controlArmOrArms} for the control: the`
				])
			}}
			{{
				$tera.project.TrialWizard.control
					? joinArrayWithAnd(
							$tera.project.TrialWizard.control.map(el => el.name + " group")
					  )
					: "BLANK"
			}}.
		</p>
		<p
			v-for="(intervention, index) of $tera.project.TrialWizard.control"
			:key="`control-${index}`"
		>
			{{
				selectRandom([
					"Participants in the ",
					"The participants assigned to the ",
					"Participants assigned to the ",
					"Participants delegated in the "
				])
			}}
			{{ intervention.name }}
			{{ selectRandom(["group received ", "group, were given "]) }}
			{{ intervention.materials }}.
			<span v-if="intervention.instructions"
				>They were instructed to {{ intervention.instructions }}.</span
			>
		</p>

		<!-- Other -->
		<p>
			{{
				selectRandom([
					"Treatment will be discontinued or modified if ",
					"Treatment of participants will be stopped or changed if ",
					"The trial will be stopped or modified, when the participants ",
					"Treatment will be stopped or changed, when the participants "
				])
			}}
			{{
				joinArrayWithOr(formatSelectMulti($tera.project.TrialWizard.discontinued))
			}}
			{{ selectRandom(["occurred.", "happened."]) }}
		</p>
		<p>
			{{
				selectRandom([
					"Adherence to intervention protocols were maintained by ",
					"Ensuring intervention protocols were followed was done by ",
					"Keeping to intervention procedures was done by ",
					"Adherence to intervention guidelines was maintained by "
				])
			}}
			{{
				joinArrayWithAnd(
					formatSelectMulti($tera.project.TrialWizard.adherenceMaintained)
				)
			}}.
			{{
				selectRandom([
					"Adherence will be monitored by ",
					"Compliance with intervention protocols will be checked by ",
					"Compliance will be monitored by ",
					" The monitoring of adherence was conducted by "
				])
			}}
			{{
				joinArrayWithAnd(
					formatSelectMulti($tera.project.TrialWizard.adherenceMonitored)
				)
			}}.
		</p>
		<p>
			{{
				selectRandom([
					"Both groups will receive ",
					"All groups in the trial will be given ",
					"All participants in the trial will be given ",
					"All participants will receive "
				])
			}}
			{{ $tera.project.TrialWizard.allInstructions }}.
			{{
				selectRandom([
					"Interventions such as: ",
					"Interventions which involved ",
					"Planned interventions are ",
					"Interventions will include: "
				])
			}}
			{{ $tera.project.TrialWizard.prohibitedInterventions }}
			{{
				selectRandom([
					" will not be allowed for the duration of the study.",
					" will not be given during the trial.",
					" will not be allowed during the study.",
					" will not be given for the duration of the study."
				])
			}}
		</p>
	</div>
</template>

<script>
import OutputMixin from "@/mixins/OutputMixin.js";
export default {
	name: "OutputInterventions",
	mixins: [OutputMixin],
	computed: {
		interventionArmOrArms() {
			return this.$tera.project.TrialWizard.interventions.length > 1
				? "arms"
				: "arm";
		},
		controlArmOrArms() {
			return this.$tera.project.TrialWizard.control.length > 1 ? "arms" : "arm";
		}
	}
};
</script>
